import { MENTION_PLACEHOLDERS } from '@d-shared/config';

export default class MentionsHelper {
  static getMentionPlaceholder(userId) {
    return MENTION_PLACEHOLDERS.user.replace('<user-id>', userId);
  }
}
